/* Tysk katalog for locale-no.js (del 3 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'set.import.packages.statusUploaded': 'Hochgeladen',
  'set.import.packages.uploadedAt': 'Hochgeladen am {date}',
  'set.import.packages.readAt': 'Zuletzt ausgelesen am {date}',
  'set.import.packages.importedAt': 'In die Buchhaltung importiert am {date}',
  'set.import.packages.notAvailable': 'Unbekannter Zeitpunkt',
  'set.import.packages.unknownSize': 'Unbekannte Größe',
  'set.import.packages.deleteConfirm': '{name} löschen? Die ZIP-Datei und temporäre Analysedaten werden dauerhaft entfernt. Aus diesem Paket wurden keine Buchhaltungsdaten importiert.',
  'set.import.packages.deletePreviousConfirm': 'Das frühere Importpaket {name} löschen? Importierte Buchhaltungsdaten bleiben erhalten. Dokumente, die nur in dieser älteren ZIP-Datei vorhanden sind, können nach dem Löschen nicht mehr geöffnet werden.',
  'set.import.packages.deleteDialogTitle': 'Importpaket löschen?',
  'set.import.packages.deleteDialogBody': 'Du bist dabei, {name} zu löschen. Die ZIP-Datei und die zugehörigen Analysedaten werden dauerhaft aus dem Backend entfernt.',
  'set.import.packages.deletePreviousBody': 'Du bist dabei, das frühere Importpaket {name} zu löschen. Buchhaltungsdaten bleiben erhalten, aber Dokumente, die nur in dieser ZIP-Datei vorhanden sind, können danach nicht mehr geöffnet werden.',
  'set.import.packages.deleteIrreversible': 'Diese Aktion kann nicht rückgängig gemacht werden.',
  'set.import.packages.replaceTitle': 'Bestehendes Importpaket ersetzen?',
  'set.import.packages.replaceBody': 'Du hast bereits das Importpaket {name}. Sobald das neue Paket analysiert und genehmigt ist, wird es aktiv und alle älteren ZIP-Pakete werden aus dem Backend gelöscht.',
  'set.import.packages.replaceSafety': 'Das bestehende Paket bleibt erhalten, während das neue hochgeladen und analysiert wird. Wenn die Analyse fehlschlägt oder abgebrochen wird, bleibt das aktuell aktive Paket unverändert.',
  'set.import.packages.replacePermanent': 'Nach der Genehmigung kann das Löschen des alten Pakets nicht rückgängig gemacht werden.',
  'set.import.packages.chooseReplacement': 'Neue ZIP wählen',
  'set.import.packages.deleteProtected': 'Das Paket wird in der Buchhaltung verwendet und kann hier nicht gelöscht werden.',
  'set.import.packages.protectedHelp': 'Dies ist die aktive Quelle für importierte Belegdokumente und kann daher nicht gelöscht werden.',
  'set.import.packages.duplicateHelp': 'Der Dateiinhalt ist identisch mit dem aktiven Importpaket und kann gelöscht werden.',
  'set.import.packages.deleting': 'Wird gelöscht...',
  'set.import.packages.delete': 'Löschen',
  'set.import.packages.deleted': 'Das Importpaket wurde gelöscht.',
  'set.import.packages.deleteFailed': 'Das Importpaket konnte nicht gelöscht werden.',
  'set.import.packages.deleteMissing': 'Der Speicherpfad für das Importpaket fehlt.',
  'set.import.packages.download': 'ZIP herunterladen',
  'set.import.packages.downloading': 'Wird vorbereitet...',
  'set.import.packages.downloadMissing': 'Der Speicherpfad für das Importpaket fehlt.',
  'set.import.packages.downloadStarted': 'Der Download der Original-ZIP wurde gestartet.',
  'set.import.packages.downloadFailed': 'Das Importpaket konnte nicht heruntergeladen werden.',
  'set.import.years.title': 'Datenjahre wählen',
  'set.import.years.help': 'Nur Daten und Zahlen für die gewählten Jahre werden importiert. Register und Dokumentenarchiv werden separat behandelt.',
  'set.import.years.recommended': 'Empfohlener Zeitraum',
  'set.import.years.previousOnly': 'Nur frühere Jahre',
  'set.import.years.all': 'Alle Jahre',
  'set.import.years.current': 'aktuelles Jahr',
  'set.import.years.retentionWarning': 'Du hast {years} abgewählt, die noch innerhalb der üblichen Aufbewahrungsfrist liegen können. Stelle sicher, dass das Material anderweitig aufbewahrt wird.',
  'set.import.years.documentsPreserved': 'Original-ZIP und Dokumentenarchiv bleiben unabhängig von der Jahresauswahl vollständig erhalten.',
  'set.import.years.importedTitle': 'Importierte Datenjahre',
  'set.import.years.importedHelp': 'Du kannst importierte Zahlen für ein Jahr entfernen, ohne ZIP, Dokumentenarchiv oder manuell erstellte Einträge zu löschen.',
  'set.import.years.removeYear': 'Importierte Daten für {year} entfernen',
  'set.import.years.removeTitle': 'Importierte Daten für {year} entfernen?',
  'set.import.years.removeBody': 'Importierte Eröffnungsbilanz, Berichtshistorie, jahresspezifische offene Posten und importierte Kontrollstatus für {year} werden entfernt.',
  'set.import.years.removePreserves': 'Manuelle Rechnungen, Einkäufe, Belege, Register, Original-ZIP und Dokumentenarchiv bleiben erhalten.',
  'set.import.years.removeConfirm': 'Daten entfernen',
  'set.import.years.removing': 'Wird entfernt...',
  'set.import.years.removed': '{count} importierte Datenpunkte für {year} entfernt.',
  'set.import.years.removeFailed': 'Importierte Jahresdaten konnten nicht entfernt werden.',
  'set.import.years.invalid': 'Wähle ein gültiges Importjahr.',
  'set.import.years.selectedLedgerRows': 'Historienzeilen in den gewählten Jahren',
  'set.showAll': 'Alle anzeigen',
  'set.count.accounts': 'Saldenkonten',
  'set.count.customers': 'Kunden',
  'set.count.products': 'Produkte',
  'set.count.openSalesInvoices': 'offene Kundenrechnungen',
  'set.count.openPurchaseInvoices': 'offene Lieferantenrechnungen',
  'set.count.suppliers': 'Lieferanten',
  'set.count.openingBalances': 'Eröffnungssalden',
  'set.import.after': 'Nach dem Import',
  'set.noMatches': 'Keine Treffer.',
  'set.preview': 'Vorschau',
  'set.previewHeading': 'So sieht das Dokument aus',
  'set.preview.sender': 'Absender:',
  'set.preview.invoiceNo': 'Rechnungsnr.:',
  'set.preview.invoiceDate': 'Rechnungsdatum:',
  'set.preview.dueDate': 'Fälligkeitsdatum:',
  'set.preview.accountNo': 'Kontonr.:',
  'set.preview.toPay': 'Zu zahlen:',
  'set.preview.docType': 'RECHNUNG',
  'set.preview.noCustomer': 'Noch kein Kunde ausgewählt',
  'set.preview.net': 'Netto',
  'set.preview.vat': 'MwSt.',
  'set.preview.toPayShort': 'Zu zahlen',
  'set.menu.title': 'Seitenmenü',
  'set.menu.help': 'Wähle, welche Seiten im Menü links angezeigt werden. Kernseiten sind immer sichtbar.',
  'set.menu.showAll': 'Alle Seiten anzeigen',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importieren',
  'set.data.accountingTitle': 'Import / Export der Buchhaltung',
  'set.data.accountingSub': 'Importiere aus einem anderen Buchhaltungssystem mit einer oder mehreren ZIP-, SAF-T-, CSV- oder Excel-Dateien und exportiere Backup und Buchungsübersicht.',
  'set.export': 'Exportieren',
  'set.data.invoiceCsv': 'Rechnungen CSV',
  'set.data.invoiceTemplate': 'Vorlage für Rechnungsimport',
  'set.data.bookkeepingCsv': 'Buchungen CSV',
  'set.data.reusePackage': 'Verwendet die hochgeladene Exportdatei erneut, ohne neuen Upload.',
  'set.data.resetAll': 'Alle Daten zurücksetzen',
  'set.data.deleteBusiness': 'Unternehmen löschen',
  'set.data.onlyOwnerSchedule': 'Nur der Eigentümer kann das Löschen planen.',
  'set.doc.tab': 'Dokumente',
  'svc.mcpMissingRedirect': 'Der MCP-Dienst hat keine sichere Weiterleitung zurückgegeben.',
  'route.dailySettlements': 'Tagesabrechnungen',
  'nav.dailySettlements': 'Tagesabrechnungen',
  'navhelp.dailySettlements': 'Tagesabrechnungen aus Kassensystemen, Buchungssystemen, Vermietungsplattformen und Onlineshops. Prüfen und genehmigen vor dem Buchen.',
  'dailySettlement.title': 'Tagesabrechnungen',
  'dailySettlement.sub': 'Abrechnungen aus Kasse, Buchung, Vermietung und Onlineshop. Nichts wird gebucht, bevor du es genehmigst.',
  'dailySettlement.refresh': 'Aktualisieren',
  'dailySettlement.loadError': 'Die Tagesabrechnungen konnten nicht geladen werden.',
  'dailySettlement.openSettings': 'Integrationen öffnen',
  'dailySettlement.emptyTitle': 'Hier gibt es keine Tagesabrechnungen',
  'dailySettlement.emptyText': 'Sobald eine Quelle verbunden ist und eine Abrechnung geliefert hat, erscheint sie hier zur Prüfung und Genehmigung.',
  'dailySettlement.filter.open': 'Zu bearbeiten',
  'dailySettlement.filter.ready': 'Bereit',
  'dailySettlement.filter.review': 'Muss geprüft werden',
  'dailySettlement.filter.done': 'Fertig',
  'dailySettlement.status.ready': 'Bereit zur Genehmigung',
  'dailySettlement.status.review': 'Muss geprüft werden',
  'dailySettlement.status.approved': 'Gebucht',
  'dailySettlement.status.dismissed': 'Ohne Buchung abgeschlossen',
  'dailySettlement.attentionTitle': 'Quellen, die Aufmerksamkeit brauchen',
  'dailySettlement.attentionStale': '{provider} hat seit {days} Tagen keine Abrechnung geliefert. Die letzte war am {date}.',
  'dailySettlement.attentionNever': '{provider} ist verbunden, hat aber noch nie eine Abrechnung geliefert.',
  'dailySettlement.homeWaiting': '{ready} bereit zur Genehmigung, {review} müssen geprüft werden.',
  'dailySettlement.homeAction': 'Tagesabrechnungen ansehen',
  'set.doc.title': 'Dokumente',
  'set.doc.sub': 'Lade eigene Dokumente hoch und bewahre sie auf, z. B. Verträge, Versicherungen oder Satzungen.',
  'set.doc.drop': 'Dateien hierher ziehen',
  'set.doc.dropHint': 'Oder tippen, um eine Datei auszuwählen',
  'set.doc.empty': 'Noch keine Dokumente hochgeladen.',
  'set.doc.added': 'Hinzugefügt',
  'set.doc.new': 'Neues Dokument',
  'set.doc.edit': 'Dokument bearbeiten',
  'set.doc.remove': 'Dokument entfernen',
  'set.doc.open': 'Dokument öffnen',
  'set.doc.add': 'Dokument hinzufügen',
  'set.doc.name': 'Name',
  'set.doc.namePh': 'Z. B. Haftpflichtversicherung 2026',
  'set.doc.nameRequired': 'Gib dem Dokument zuerst einen Namen',
  'set.doc.type': 'Typ',
  'set.doc.attachTo': 'Standardmäßig angehängt an',
  'set.doc.attachToHint': 'Das Dokument wird diesen Dokumenttypen an Kunden automatisch beigefügt — kann pro Versand entfernt werden.',
  'set.doc.uploading': 'Wird hochgeladen...',
  'set.doc.uploaded': 'Dokument hochgeladen',
  'set.doc.saved': 'Dokument aktualisiert',
  'set.doc.deleted': 'Dokument entfernt',
  'set.doc.deleteConfirm': 'Das Dokument „{name}“ löschen?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG oder WEBP. Max. 10 MB.',
  'set.doc.unavailable': 'Die Dokumentenseite wurde nicht geladen. Lade die Seite neu — wenn sie weiterhin leer ist, handelt es sich um einen Fehler, den wir uns ansehen müssen.',
  'set.doc.target.offer': 'Angebote',
  'set.doc.target.orderConfirmation': 'Auftragsbestätigungen',
  'set.doc.target.invoice': 'Rechnungen',
  'set.doc.target.creditNote': 'Gutschriften',
  'set.doc.target.subscription': 'Abonnements und Listen',
  'set.doc.target.subscriptionHint': 'Wird E-Mails beigefügt, die du aus einem Abonnement oder einer Kundenliste sendest.',
  'set.doc.kind.agreement': 'Vertrag',
  'set.doc.kind.insurance': 'Versicherung',
  'set.doc.kind.articles': 'Satzung / Gründungsdokument',
  'set.doc.kind.authorization': 'Vollmacht',
  'set.doc.kind.certificate': 'Zertifikat',
  'set.doc.kind.standard_attachment': 'Standardanhang',
  'set.doc.kind.other': 'Sonstiges',
  'sale.att.standard': 'Standard',
  'sale.att.removeStandard': 'Diesmal nicht beifügen',
  'sale.att.remove': 'Anhang entfernen',
  'sub.standardDocs': 'Beigefügte Standarddokumente: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Buchhaltungseinrichtung',
  'set.acc.sub': 'Grundeinstellungen für die Buchhaltung: erstes Geschäftsjahr, MwSt.-Registrierung, Buchführungsmethode und Ähnliches.',
  'set.acc.startYear': 'Startjahr',
  'set.acc.startYearHelp': 'Das erste Geschäftsjahr, das du in Plumme führst. Belege und Berichte vor diesem Jahr gehören in ein früheres System.',
  'set.acc.startInvoiceNo': 'Start-Rechnungsnummer',
  'set.acc.startInvoiceNoHelp': 'Die Nummer, die deine erste Rechnung erhalten soll. Kommst du von einem anderen System, setze sie höher als die zuletzt verwendete Nummer, damit du eine lückenlose Nummernfolge hast (eine gesetzliche Pflicht).',
  'set.acc.vatStatus': 'MwSt.-Status',
  'set.acc.vatStatusHelp': 'Ob das Unternehmen im Merverdiavgiftsregisteret eingetragen ist. Du wirst MwSt.-pflichtig, wenn der steuerpflichtige Umsatz in 12 Monaten 50 000 kr übersteigt. MwSt.-registriert bedeutet, dass du MwSt. auf Verkäufe erhebst und beim Einkauf Vorsteuer abziehen kannst.',
  'set.acc.vatRegistered': 'MwSt.-registriert',
  'set.acc.notVatRegistered': 'Nicht MwSt.-registriert',
  'set.acc.vatRegisteredFrom': 'MwSt.-registriert ab',
  'set.acc.vatRegisteredWhen': 'War das Unternehmen bereits am 1. Januar {year} MwSt.-registriert?',
  'set.acc.vatRegisteredWhenHelp': 'Die Buchhaltung in Plumme beginnt {year}. Ab dem MwSt.-Datum wird MwSt. auf Verkäufe und Käufe berechnet — davor keine. Antwortest du „ja“, wird das Datum auf den 1. Januar {year} gesetzt.',
  'set.acc.vatRegisteredPick': 'Antwort wählen',
  'set.acc.vatRegisteredAtStart': 'Ja, vor {year} registriert',
  'set.acc.vatRegisteredLater': 'Nein, im Laufe von {year} oder später registriert',
  'set.acc.vatRegisteredUnknown': 'Weiß nicht',
  'set.acc.vatRegisteredFromHelp': 'Das Datum, an dem das Unternehmen MwSt.-registriert wurde. Vor diesem Datum wird keine MwSt. berechnet; ab diesem Datum wird MwSt. auf Verkäufe und Käufe gebucht.',
  'set.acc.standardVat': 'Vorschlag für neue Verkaufszeilen',
  'set.acc.standardVatHelp': 'Das ist nur der Satz, den Plumme vorschlägt, wenn du eine neue Verkaufszeile anlegst. Das Unternehmen kann mehrere MwSt.-Sätze verwenden, und das Produkt oder die Rechnungszeile kann den Vorschlag überschreiben.',
  'set.acc.howFileVat': 'Wie reichst du die MwSt. ein',
  'set.acc.vatPeriod': 'MwSt.-Zeitraum',
  'set.acc.vatPeriodHelp': 'Wie oft du die MVA-melding einreichst. Die meisten reichen alle zwei Monate ein (6 Zeiträume pro Jahr). Kleine Unternehmen unter 1 Mio. kr können eine jährliche Abgabe beantragen. Vierteljährlich und monatlich wird in Sonderfällen verwendet.',
  'set.acc.midYearTitle': 'Start mitten im Jahr (Startzahlen)',
  'set.acc.midYearHelp': 'Nutze dies, wenn du Plumme mitten in einem Geschäftsjahr einführst. Dann gibst du Startzahlen — Umsätze, Kosten und MwSt. bisher im Jahr — aus dem alten System ein, damit Jahresberichte und MVA-melding mit den richtigen Zahlen fortgeführt werden.',
  'set.acc.midYear': 'Start mitten im Jahr',
  'set.acc.enterOpening': 'Startzahlen eingeben',
  'set.acc.enterOpeningHelp': 'Öffnet das Formular, in dem du Übergangsdatum, bisherige MwSt. und Umsätze/Kosten nach Konto aus dem bisherigen System erfasst.',
  'set.acc.ibHelp': 'Der Anfangsbestand umfasst die Vermögenswerte, das Eigenkapital und die Verbindlichkeiten des Unternehmens zu Jahresbeginn — also den Endbestand des Vorjahres. Gib ihn ein, wenn du ein neues Geschäftsjahr in Plumme beginnst, damit die Bilanz vom ersten Tag an stimmt.',
  'set.acc.viewIb': 'Anfangsbestand ansehen / bearbeiten',
  'set.acc.viewIbHelp': 'Öffnet den gebuchten Anfangsbestand, wo du die Zeilen sehen, bearbeiten oder den Anfangsbestand löschen kannst.',
  'set.acc.addIb': 'Anfangsbestand eingeben',
  'set.acc.addIbHelp': 'Öffnet einen Assistenten, der dir hilft, den Anfangsbestand einzurichten — du bestätigst das Startdatum und gibst die Bilanzzeilen (Soll/Haben) aus dem Vorjahr ein.',
  'set.acc.extraAccountsHelp': 'Füge zusätzliche Konten nur hinzu, wenn die Summen- und Saldenliste oder der Export sie benötigen.',
  'set.acc.searchPlaceholder': 'Kontenplan nach Nummer oder Name durchsuchen',
  'set.acc.searchNoHits': 'Keine Konten passen zu „{query}“.',
  'set.acc.addAccount': 'Konto hinzufügen',
  'set.acc.addAccountHelp': 'Erstellt ein eigenes Konto im Kontenplan. Verwende das nur, wenn ein benötigtes Konto fehlt — die meisten Standardkonten gibt es bereits.',
  'set.acc.accountNameHelp': 'Ein aussagekräftiger Name für das Konto, wie er im Kontenplan und in den Berichten erscheint — z. B. „Software/Abonnement“.',
  'set.acc.accountNoHelp': 'Vierstellige Kontonummer. Die erste Ziffer bestimmt die Kontenklasse: 1 Vermögenswerte, 2 Eigenkapital/Verbindlichkeiten, 3 Erträge, 4–7 Aufwendungen, 8 Finanzen und Steuern.',
  'set.acc.accountClass': 'Kontenklasse',
  'set.acc.accountClassHelp': 'Die Hauptgruppe, der das Konto angehört, automatisch aus der ersten Ziffer der Kontonummer abgeleitet. Sie bestimmt, ob das Konto ein Vermögenswert, eine Verbindlichkeit, ein Ertrag oder ein Aufwand ist.',
  'set.acc.equivalent': 'Entspricht Konto',
  'set.acc.equivalentHelp': 'Verknüpft das eigene Konto mit einem Standardkonto. So weiß Plumme, wie das Konto beim Jahresabschluss und in der Steuererklärung behandelt werden soll — damit eigene Konten richtig in den amtlichen Formularen landen.',
  'set.acc.createAccount': 'Konto erstellen',
  'set.acc.ownAccounts': 'Eigene Konten',
  'set.acc.ownAccountsHelp': 'Die Konten, die du selbst über den Standardkontenplan hinaus hinzugefügt hast. Nur diese können geändert oder gelöscht werden.',
  'set.acc.noOwnAccounts': 'Noch keine eigenen Konten.',
  'set.acc.removeAccount': 'Konto entfernen',
  'set.acc.deactivated': 'deaktiviert',
  'set.acc.standardAccounts': 'Standardkonten',
  'set.acc.standardAccountsHelp': 'Der integrierte Standardkontenplan (NS 4102). Diese Konten sind für alle gleich und werden beim Buchen automatisch verwendet — eigene Konten brauchst du selten.',
  'set.bank.title': 'Bankabstimmung',
  'set.bank.help': 'Die Bankabstimmung hilft dir zu prüfen, dass Käufe, Verkäufe und Zahlungen genau einmal gebucht sind und mit dem Geschäftskonto übereinstimmen.',
  'set.bank.activeFrom': 'Aktiv ab',
  'set.bank.accounts': 'Bankkonten',
  'set.bank.primaryHelp': 'Das primäre Rechnungskonto ist das Standardkonto, auf das Kunden zahlen.',
  'set.bank.disabled': 'Deaktiviert',
  'set.bank.invoiceAccount': 'Rechnungskonto',
  'set.bank.activate': 'Konto aktivieren',
  'set.bank.setAsInvoice': 'Als Rechnungskonto festlegen',
  'set.bank.accountNumber': 'Kontonummer',
  'set.bank.ledgerAccount': 'Konto in der Buchhaltung',
  'set.bank.type': 'Typ',
  'set.bank.typeOperating': 'Betrieb',
  'set.bank.typeTax': 'Steuereinbehalt',
  'set.bank.typeSavings': 'Sparen',
  'set.bank.typePrivate': 'Privat',
  'set.bank.typeOther': 'Sonstiges',
  'set.bank.openingBalance': 'Anfangssaldo für die Bankabstimmung',
  'set.bank.openingBalanceDate': 'Datum des Anfangssaldos',
  'set.bank.reconcileIn': 'In Bank abstimmen',
  'set.bank.mustReconcile': 'Muss abgestimmt werden',
  'set.bank.showInPayments': 'In „Bezahlt von/an“ anzeigen',
  'set.bank.none': 'Es sind noch keine Bankkonten erfasst.',
  'set.bank.cards': 'Mit dem Konto verknüpfte Karten',
  'set.bank.cardsHelp': 'Belege zeigen oft nur die letzten vier Ziffern. Erfasse die Karte, dann erkennt Plumme die Zahlung, ohne auf den Kontoauszug zu warten. Die Kontoart entscheidet, ob der Einkauf betrieblich oder eine private Auslage ist.',
  'set.bank.cardsNone': 'Das Konto hat keine Karte',
  'set.bank.cardsNoneHelp': 'Setze hier ein Häkchen oder erfasse die Karten bei jedem Zahlungskonto. Sobald alle Konten geklärt sind, weiß Plumme, welche Karten das Unternehmen hat: Ein mit einer anderen Karte bezahlter Beleg wird dann als private Auslage vorgeschlagen, mit Vermerk auf dem Beleg.',
  'set.bank.cardPromptTitle': 'Die Karten entscheiden über betrieblich oder privat',
  'set.bank.cardPromptBody': 'Plumme liest die Kartennummer vom Beleg. Wenn wir wissen, welche Karten das Unternehmen hat, wird jeder Kartenkauf automatisch zugeordnet: Kennen wir die Karte, ist es ein betrieblicher Einkauf — bei einer anderen Karte eine private Auslage. Für diese Konten fehlt die Antwort:',
  'set.bank.cardPromptSkipHelp': 'Wenn du überspringst, bleibt das Konto ungeklärt, und bei Kartenbelegen muss die Zahlungsquelle manuell gesetzt werden. Du kannst das jederzeit nachtragen.',
  'set.bank.cardPromptFill': 'Jetzt ausfüllen',
  'set.bank.cardPromptSkip': 'Ohne speichern',
  'set.bank.accountFallback': 'Bankkonto',
  'set.bank.receiptDefault': 'Standard-Zahlungsquelle für Belege',
  'set.bank.receiptDefaultSub': 'Wird nur verwendet, wenn weder Karte, Kontoauszug noch Verlauf zeigen, von wo der Einkauf bezahlt wurde.',
  'set.bank.receiptDefaultLabel': 'Zahlungsquelle',
  'set.bank.receiptDefaultHint': 'Der Beleg wird buchungsbereit, aber orange markiert, um zu zeigen, dass die Quelle vorausgewählt und nicht aus dem Dokument gelesen wurde.',
  'set.bank.receiptDefaultNone': 'Keine – Beleg zur Prüfung liegen lassen',
  'set.bank.cardLast4': 'Letzte vier Ziffern',
  'set.bank.cardLabel': 'Name der Karte',
  'set.bank.cardLabelPh': 'Z. B. Visa privat',
  'set.bank.cardAdd': 'Karte hinzufügen',
  'set.bank.cardRemove': 'Karte entfernen',
  'set.bank.cardLast4Invalid': 'Gib die letzten vier Ziffern der Karte ein.',
  'set.bank.cardDuplicate': 'Die Karte ist bereits erfasst. Zwei Karten mit denselben vier Ziffern lassen sich auf einem Beleg nicht unterscheiden.',
  'set.access.title': 'Zugriff',
  'set.access.sub': 'Lade Buchhalter oder Partner mit eigenem Login ein. Der Zugriff wird über Rollen gesteuert.',
  'set.access.activeBusiness': 'Aktives Unternehmen',
  'set.access.active': 'Aktiv',
  'set.access.noBusinesses': 'Mit dem Benutzer ist noch kein Unternehmen verknüpft.',
  'set.access.newBusiness': 'Neues Unternehmen',
  'set.access.inviteTitle': 'Partner einladen',
  'set.access.inviteSub': 'Lade deinen Buchhalter oder andere Partner ein und sieh dir ausstehende Einladungen an.',
  'set.access.noAdmin': 'Du hast im gewählten Unternehmen keine Admin-Rolle.',
  'set.access.noAdminSub': 'Nur Eigentümer und Admins können neue Benutzer einladen.',
  'set.access.email': 'E-Mail',
  'set.access.role': 'Rolle',
  'set.role.accountant': 'Buchhalter',
  'set.role.admin': 'Admin',
  'set.role.viewer': 'Lesezugriff',
  'set.access.sendInvite': 'Einladung senden',
  'set.access.invites': 'Einladungen',
  'set.access.invitesSub': 'Ausstehende Einladungen für das aktive Unternehmen.',
  'set.access.accept': 'Annehmen',
  'set.access.pending': 'Ausstehend',
  'set.access.withdraw': 'Zurückziehen',
  'set.access.noInvites': 'Keine ausstehenden Einladungen.',
  'set.access.deleteNote': 'Löscht nur das gewählte Unternehmen, nicht dein Login oder andere Unternehmen.',
  'set.access.deleteBusiness': 'Dieses Unternehmen löschen',
  'set.access.onlyOwnerDelete': 'Nur der Eigentümer kann Unternehmen löschen.',
  'set.saveChanges': 'Änderungen speichern',
  'set.title': 'Einstellungen',
  'set.subtitle': 'Unternehmen, Benutzerprofil, Zugriff, Buchhaltung, Bank, Investitionen und Daten an einem Ort.',
  'set.tabsTitle': 'Einstellungs-Tabs',
  'set.tabsHelp': 'Jeder Tab ist ein Einstellungsbereich: Unternehmen (Firmenangaben), Benutzerprofil (du), Zugriff (wer was darf), Präferenzen (Benachrichtigungen und Anzeige), Buchhaltung (Einrichtung und Kontenplan), Bank, Investitionen, Daten (Import/Export), Dokumente, Integrationen und Abonnement.',
  'set.company': 'Unternehmen',
  'set.country': 'Land',
  'set.companyName': 'Unternehmensname',
  'set.orgNumber': 'Organisationsnummer',
  'set.phone': 'Telefon',
  'set.address': 'Adresse',
  'set.zip': 'PLZ',
  'set.city': 'Ort',
  'set.companyType': 'Rechtsform',
  'set.logo': 'Firmenlogo',
  'set.logoAlt': 'Logo',
  'set.logoHelp': 'Logo für Rechnungen. PNG, JPG oder WebP, max. 1 MB.',
  'set.uploadLogo': 'Logo hochladen',
  'set.previewInvoice': 'Rechnungsvorschau',
  'set.deleteLogo': 'Logo löschen',
  'set.inboxEmail': 'E-Mail für den Beleg-Posteingang',
  'set.inboxEmailHelp': 'Leite Lieferantenrechnungen und Quittungen hierher weiter, um Belege direkt in den Posteingang zu legen.',
  'set.copyEmail': 'E-Mail kopieren',
  'set.generateEmail': 'Neue E-Mail generieren',
  'set.generateEmailHelp': 'Nur ändern, wenn die Adresse durchgesickert ist oder Spam erhält. Bestehende Integrationen müssen aktualisiert werden.',
  'set.profile': 'Benutzerprofil',
  'set.profileSub': 'Angaben, die zu deinem Login gehören.',
  'set.loggedInEmail': 'Angemeldete E-Mail',
  'set.mobile': 'Handynummer',
  'set.saveProfile': 'Benutzerprofil speichern',
  'set.subscription': 'Abonnement',
  'set.subscriptionSub': 'Die Abrechnung wird über Backend und Stripe gesteuert, nicht über einen lokalen Testplan.',
  'set.openPortal': 'Kundenportal öffnen',
  'set.current': 'Aktuell',
  'adv.eyebrow': 'Finanzberater',
  'adv.beta': 'Beta',
  'adv.updating': 'Wird aktualisiert',
  'adv.lead': 'SuperPlumma analysiert deine Buchhaltung und berät dich wie ein erfahrener Finanzchef — für {year}.',
  'adv.tab.overview': 'Übersicht',
  'adv.tab.liquidity': 'Liquidität & Risiko',
  'adv.tab.sales': 'Umsatz & Rentabilität',
  'adv.tab.costs': 'Kosten',
  'adv.sales.title': 'Umsatz und Rentabilität',
  'adv.sales.sub': 'Gebuchte Ausgangsrechnungen für {year}',
  'adv.sales.help': 'Alle Zahlen hier werden aus den gebuchten Ausgangsrechnungen im gewählten Jahr berechnet und mit denselben Zahlen des Vorjahres verglichen. Entwürfe, Gutschriften und Angebote sind nicht enthalten.',
  'adv.sales.emptyTitle': 'Noch keine gebuchten Ausgangsrechnungen',
  'adv.sales.emptyText': 'Sobald du Verkäufe gebucht hast, berechne ich Kundenrentabilität, Zahlungsdauer, Rabattniveau und welche Produkte wachsen.',
  'adv.sales.periodYear': 'in {year}',
  'adv.sales.periodVsPrev': 'ggü. {year}',
  'adv.sales.invoiceCount': '{count} Rechnungen',
  'adv.sales.customerCount': '{count} Kunden',
  'adv.sales.recurringCount': '{count} mit wiederkehrender Abrechnung',
  'adv.sales.days': '{days} Tage',
  'adv.sales.noPayments': 'Noch nichts bezahlt',
  'adv.sales.kpi.revenue': 'Umsatz',
  'adv.sales.kpi.growth': 'Umsatzwachstum',
  'adv.sales.kpi.growthHelp': 'Veränderung des gebuchten Umsatzes gegenüber dem gleichen Zeitraum im Vorjahr. Wird als „—“ angezeigt, wenn keine Vorjahreszahlen zum Vergleich vorliegen.',
  'adv.sales.kpi.avgInvoice': 'Durchschnittlicher Rechnungsbetrag',
  'adv.sales.kpi.discount': 'Durchschnittlicher Rabatt',
  'adv.sales.kpi.discountHelp': 'Gesamtrabatt geteilt durch den Wert der Rechnungen ohne Rabatt. Steigt die Zahl, ohne dass das Volumen steigt, verschenkst du Marge, ohne etwas dafür zu bekommen.',
  'adv.sales.kpi.paymentDays': 'Zahlungsdauer',
  'adv.sales.kpi.paymentDaysHelp': 'Durchschnittliche Anzahl Tage vom Rechnungsdatum bis zur erfassten Zahlung. Nur bezahlte Rechnungen zählen — unbezahlte erhöhen den Durchschnitt nicht.',
  'adv.sales.kpi.repeat': 'Wiederkaufrate',
  'adv.sales.kpi.repeatHelp': 'Anteil der Kunden mit mehr als einer Rechnung im Jahr. Eine hohe Wiederkaufrate sorgt für besser planbaren Umsatz als derselbe Umsatz verteilt auf Einmalkunden.',
  'adv.sales.kpi.concentration': 'Kundenkonzentration',
  'adv.sales.kpi.concentrationHelp': 'Welcher Anteil des Umsatzes vom größten Kunden stammt. Über 40 % bedeutet, dass ein einzelner Kunde das Geschäft allein ins Wanken bringen kann.',
  'adv.sales.kpi.recurring': 'Wiederkehrende Einnahmen',
  'adv.sales.kpi.recurringHelp': 'Anteil des Umsatzes aus Rechnungen mit wiederkehrender Abrechnung oder Abonnement.',
  'adv.sales.customers': 'Kundenrentabilität',
  'adv.sales.customersSub': 'Umsatz, Zahlungsdauer und Rabattniveau pro Kunde',
  'adv.sales.customersHelp': 'Die Kunden sind nach Umsatz im gewählten Jahr sortiert. Der Trend vergleicht mit dem Vorjahr — ein neuer Kunde ohne Vorjahreszahlen erhält eine eigene Markierung statt eines Pfeils.',
  'adv.sales.col.customer': 'Kunde',
  'adv.sales.col.revenue': 'Umsatz',
  'adv.sales.col.grossProfit': 'Rohertrag',
  'adv.sales.col.paymentSpeed': 'Zahlungsdauer',
  'adv.sales.col.discount': 'Rabatt',
  'adv.sales.col.jobs': 'Rechnungen',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Nicht berechnet',
  'adv.sales.trendNew': 'Neuer Kunde in diesem Jahr',
  'adv.sales.showAll': 'Alle {count} Kunden anzeigen',
  'adv.sales.showFewer': 'Weniger anzeigen',
  'adv.sales.profitNote': 'Der Rohertrag wird angezeigt, wenn für alle Rechnungspositionen des Kunden ein Einstandspreis erfasst ist. Ältere Rechnungen und Positionen ohne Einstandspreis werden als „Nicht berechnet“ angezeigt.',
  'adv.sales.products': 'Produkte und Dienstleistungen',
  'adv.sales.productsSub': 'Umsatz pro Produkt und was wächst oder sinkt',
  'adv.sales.productsHelp': 'Die Produkte stammen aus den Rechnungspositionen. Positionen ohne Produktnamen werden unter „Ohne Produktnamen“ zusammengefasst. Wachstum und Rückgang werden am selben Produkt im Vorjahr gemessen.',
  'adv.sales.topRevenue': 'Höchster Umsatz',
  'adv.sales.growing': 'Stärkstes Wachstum',
  'adv.sales.falling': 'Stärkster Rückgang',
  'adv.sales.noComparison': 'Keine Vorjahreszahlen zum Vergleich',
  'adv.sales.verdictTag': 'Umsatz und Rentabilität im Moment',
  'adv.sales.verdict.concentration': '{name} steht für {pct} % des Rechnungsumsatzes von {revenue}. Das ist derzeit das größte Risiko in deinem Umsatz — fällt dieser Kunde weg, verschwindet der Großteil des Umsatzes mit ihm.',
  'adv.sales.verdict.slowPayers': 'Der Umsatz an sich sieht gut aus, aber {count} Kunde(n) zahlen langsam — der langsamste braucht {days} Tage. Das Geld ist verdient; es steht nur länger aus als nötig.',
  'adv.sales.verdict.discounts': 'Du gewährst im Schnitt {pct} % Rabatt, insgesamt {amount} in diesem Jahr. Das ist Geld, für das du bereits verkauft hast — es lohnt sich zu prüfen, ob der Rabatt tatsächlich Volumen bringt.',
  'adv.sales.verdict.growing': 'Der Umsatz wächst um {pct} % gegenüber dem Vorjahr und liegt jetzt bei {revenue}. Nichts in den Umsatzzahlen erfordert gerade eine Maßnahme — das Wichtigste ist, so weiterzumachen.',
  'adv.sales.verdict.shrinking': 'Der Umsatz ist gegenüber dem Vorjahr um {pct} % gesunken und liegt bei {revenue}. Das ist derzeit das deutlichste Signal in deinen Umsatzzahlen.',
  'adv.sales.verdict.steady': 'Der Umsatz liegt bei {revenue}, verteilt auf {count} Rechnungen. Ich sehe keine Warnsignale in den Umsatzzahlen — die Maßnahmen unten sind Chancen, keine Probleme.',
  'adv.sales.moves.title': 'Das würde ich zuerst tun',
  'adv.sales.moves.sub': 'Priorisierte Maßnahmen, nach Wirkung sortiert',
  'adv.sales.moves.help': 'Hinter jeder Maßnahme steht eine Zahl aus deinen eigenen Rechnungen. Die Wirkungsart gibt an, um welche Größe es sich handelt — Tage, Kronen oder Anteil — und sie dürfen nie zusammengezählt werden.',
  'adv.sales.move.chaseSlowPayers.title': 'Langsamste Zahler nachverfolgen',
  'adv.sales.move.chaseSlowPayers.text': '{count} Kunde(n) zahlen langsamer als die übrigen. {name} braucht im Schnitt {days} Tage.',
});
